import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.holybible365.com/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  signup: (data) => api.post('/auth/signup', data),
  login: (data) => api.post('/auth/login', data),
};

export const progressAPI = {
  start: () => api.post('/progress/start'),
  getStatus: () => api.get('/progress/status'),
  completeDay: (dayNumber) => api.post(`/progress/complete/${dayNumber}`),
  getAllProgress: () => api.get('/progress/all'),
};

export const planAPI = {
  getDay: (dayNumber) => api.get(`/plan/day/${dayNumber}`),
  getAll: () => api.get('/plan/all'),
};

export const bibleAPI = {
  getVerse: (book, chapter, verse, language) => 
    api.get(`/bible/verse/${book}/${chapter}/${verse}?language=${language}`),
  getChapter: (book, chapter, language) => 
    api.get(`/bible/chapter/${book}/${chapter}?language=${language}`),
};

export const readingAPI = {
  fetchReading: (readingText, language) => 
    api.post('/reading/fetch', { readingText, language }),
};

export default api;
